import { Model, Observable, ObservableArray } from '@common/nav';
import { fn, IInfOperation } from '@common/utils';
import { IPersistentSetting, CreateSetting } from '@common/services/settingsservice';
import { ApplyStyle } from '@common/style';
import { ModalShowMultiSelect } from '@common/navkendo/multiselect';
import { NavKendoRegister, constants, GetRowItem, GetGroupInfo, GetGrid, CreatePopUpOverlay, IGridCustomization, ensureRowInfo } from './kutils';

/** the full namespace (needed for template calls) */
// MSQQQ!!!!
const _NameSpace = "infoma.kwidgets";

/** Custom Extension of Base Kendo Grid :
    - Row Navigation
    - Selection over paging ...
 */
export class INavGridImp extends kendo.ui.Grid {
  /** Grid Content might get reCreated : "setOptions" -> this Event gets called when grid got created/reCreated */
  static GridContentCreated = "GridContentCreated";
  /** Any column Manipulation("Reorder, Show/ Hide ...") events */
  static ColumnChangeEvents = ["columnHide", "columnShow", "columnResize", "columnReorder", "customColumnChange"];
  /** Allows to react on'Current Selected (Cell, Row, ...) change, by hacked overwrites
  * (Once we only use Q1.2016 we can remove this: 'navigate' is a base event in this version)
  */
  protected _preventEdit = false;
  static CurrentChanged = "currentChanged";
  constructor(element, options: NavGridOptions) {
    super(element, resolveCustomOptions());
    // as long as we need to work with kendo Q1.2015
    this.bind("navigate", () => this.trigger(INavGridImp.CurrentChanged));
    function resolveCustomOptions() {
      if (options.customMultiSelect) {
        options.columns.unshift(INavGridImp.GetMultiSelectCol());
      }

      if (!("mobile" in options)) {
        // in 'mobile' mode, grid must be attached to dom for custom col handling to work
        // but we generate grid on unattached elements ....
        options.mobile = false;
      }

      // options.customColMenu default to true if not explicitly set to false!
      allColumns = (options.customColMenu = (options.customColMenu !== false)) && options.columns;
      if (allColumns && allColumns.length > 0) {
        if (options.columnMenu == true)
          options.columnMenu = {};
        if (options.columnMenu)
          options.columnMenu.columns = false;

        options.columns = INavGridImp._customCols(options, allColumns);
      }
      return options;
    }
    this.element.data("kendoGrid", this); // we removed "standard" way to handle this, but used it this way ...
    CreateGridOverlay(this);

    var allColumns: kendo.ui.GridColumn[];
    this._initCustomColSelection(allColumns);
    this._initCustomMultiSelect();

    // Handle Resize on data Changes ...
    this.bind("dataBound", () => {
      // Find parent elements with kendoNavCollapsible or kendoNavDockZone data
      var parents = this.wrapper.parents('*');
      var match = parents.filter(function () {
        return $(this).data('kendoNavCollapsible') !== undefined ||
          $(this).data('kendoNavDockZone') !== undefined;
      }).first();
      var widget = match.length && kendo.widgetInstance(match);
      if (widget) {
        widget.resize();
      }
    });
    this.bind(INavGridImp.GridContentCreated, () => {
      // Add row navigation (up/down)
      if (this.options.navigatable) {
        this.AddRowNavigation();
      }
      this.content.bind("dblclick.nav", ev => {
        if (options && $.isFunction(options.dblClick))
          options.dblClick({ item: GetRowItem(ev), event: ev });
      });

      if (this.options.columnMenu) {
        // show column menu on right click also (compatibility to asp imp.)
        $(this.thead)
          .on("contextmenu.nav", (e) => false) // supress default browser context menu
          .on("mousedown.nav", e => {
            if (e.target && e.button == 2) { // "2" : right mouse button
              var jhead = $(e.target).closest("th.k-header");
              $(".k-header-column-menu", jhead).click();
            }
          });

        // Select row/col on right mouse click (ensure ContextMenu without previous row selection)
        var grid = this;
        $(this.content).on("mousedown.nav", "tr[role='row']", e => {
          if (e.which === 3) {
            let row = $(e.target).closest("tr[role='row']");
            let isCurrentRowSelected = row.hasClass("k-state-selected");
            let selectionCount = grid.select().length;

            if (selectionCount !== 0 && !isCurrentRowSelected) {
              row.siblings().removeClass("k-state-selected");
            }
            grid.select(row);
          }
        });
      }
    });

    if (options.storeGroupingState) {
      this._initGroupingState(options.groupingState, options.storeGroupingState.key);
    }
    if (typeof options.beforeEdit === "function") {
      this.bind("beforeEdit", options.beforeEdit.bind(this));
    }

    // Grouping description
    if (options.groupingDescription) {
      var groupingDescription = options.groupingDescription + " ";
      var setGroupingDescription = () => {
        // Set custom grouping title (on non-empty grouping)
        var groupingHeader = this.element.find(".k-grouping-header");
        var groupingCount = groupingHeader.children().length;
        if (groupingHeader.length > 0 && groupingCount > 0) {
          // Grid internal grouping refresh function is triggered after databound (with empty() text).
          // There is no public event for it, so delay the setText.
          setTimeout(() => {
            var existingTextNode = groupingHeader.contents().filter(function () { return this.nodeType === 3; }).first();
            if (existingTextNode.length === 1) {
              // Update existing text
              existingTextNode.text(groupingDescription);
            } else {
              // Add new text
              var textNode = document.createTextNode(groupingDescription); // .text() includes .empty() and would remove all groupings, so add text node.
              groupingHeader.prepend(textNode);
            }
          }, 1);
        }
      };
      this.bind("dataBound", setGroupingDescription);
      setGroupingDescription(); // Ensure display of description if dataBound already fired!
    }

    this.trigger(INavGridImp.GridContentCreated);
  }

  /** Force Display to Be readonly? */
  InfReadonly?: boolean;

  /** Container of UI Attachable Actions */
  Actions: { [name: string]: IInfOperation } = {};
  private createAction<T>(name: string, f: Function, template?: T): IInfOperation & T {
    var result;
    fn.ExtendObject(result = this.Actions[name] = <IInfOperation>{ Execute: f }, template || {});
    return result;
  }

  //# region Hack : Overwrite to allow reaction on current Change ...*/

  current(el?: JQuery) {
    if (!el || !el.length)
      return super.current();

    var prev = this.current();
    var result = super.current(el);
    if (prev !== result)
      this.trigger(INavGridImp.CurrentChanged);
    return <any>result;
  }

  private _removeCurrent() {
    var prev = this["_current"];
    var result = super["_removeCurrent"].bind(this)();
    if (prev !== this["_current"])
      this.trigger("currentChanged");
    return result;
  }
  //#endregion

  /** Adds row navigation with up/down key (grid option "navigatable" must be set to true) */
  private AddRowNavigation() {
    var me = this;
    me.table.on("keydown.nav", function (e) {
      if (e.which == kendo.keys.UP || e.which == kendo.keys.DOWN) {
        setTimeout(function () {
          // Get current cell
          var activeCell = $("#aria_active_cell", me.table);
          if (activeCell.length == 0) {
            activeCell = $("#grid_active_cell", me.table);
          }
          var activeRowElem = activeCell.closest("tr")[0];

          // Clear multiple selections
          me.clearSelection();
          // Select previous/next row
          if (activeRowElem) {
            me.select($(activeRowElem));
          }
        }, 1);
      }
    });
  }

  //#region  Custom MultiSelect Checkbox functionality

  _initCustomMultiSelect() {
    if (this.CustomSelectionActive)
      return; // prevent multiple Initialization;

    var opt = (<NavGridOptions>this.options).customMultiSelect;
    if (!(this.CustomSelectionActive = !!opt))
      return;

    var fieldName = typeof (opt) == "string" ? <string>opt : "uid";
    var grid = <INavGridImp>this;

    /** Utility to be called on Change Event from GridEx */
    function refreshStateToUI() {
      var items = $("tr:not('.k-grouping-row')", grid.content),
        hasChecked = false,
        hasUnchecked = false;

      // Set Checkbox State per Row
      items.toArray().forEach(row => {
        var dataItem = grid.dataItem(row),
          isChecked = !!customSelection.GetSelected(dataItem);
        hasChecked = hasChecked || isChecked;
        hasUnchecked = hasUnchecked || !isChecked;
        $(row).toggleClass("k-state-checked", isChecked);
        $(".navRowCheckbox", row).each((idx, element: HTMLInputElement) => {
          element.checked = isChecked;
        });
      });

      // Refresh Header Checkbox state
      $(".navheaderCheckbox", grid.thead).each((idx, cb: HTMLInputElement) => {
        if (!cb["__ToggleGridSelectAll"]) { // Bind to onchange will not fire on on first indeterminate so do it this way
          $(cb).on("click.nav", cb["__ToggleGridSelectAll"] = ToggleGridSelectAll);
        }

        cb.indeterminate = hasUnchecked && hasChecked;
        cb.checked = hasChecked && !hasUnchecked;
        (hasChecked || hasUnchecked) ? $(cb).show() : $(cb).hide();
      });
    }

    /** Utility to be called after DataBound Event from GridEx */
    function OnDataBound() {
      revalidate();

      refreshStateToUI();
    }

    /**To Be Called from Header Selection onGridEx */
    function ToggleGridSelectAll(event) {
      var cb = <HTMLInputElement>event.target;
      var isChecked = (!!cb.checked || cb.indeterminate);
      var rows = $("tr:not('.k-grouping-row')", grid.content);
      customSelection.SetRowsSelected(isChecked, rows);
    }

    const CreateSelectedItems = () => {
      var items = new ObservableArray([]);
      var state = new Object();
            var result : IGridSelection = {
        ClearSelection: () => { items.splice(0, items.length); state = new Object(); },
        GetSelected: (obj) => state[obj[fieldName]] == true,
        SetSelected: (val, ...objs: kendo.data.ObservableObject[]) => {
          var hasChanges = false;
          var toAdd = new Array<kendo.data.ObservableObject>();
          var toRemove = new Array<kendo.data.ObservableObject>();
          try {
            objs.forEach(obj => {
              var curr = !!state[obj[fieldName]];
              if (curr != val) {
                hasChanges = true;
                if (val)
                  toAdd.push(obj);
                else
                  toRemove.push(obj);

                if (val)
                  state[obj[fieldName]] = val;
                else
                  delete state[obj[fieldName]];
              }
            });
          } finally {
            if (toRemove.length > 0) {
              // Bulk Remove on Observable Array ?
              toRemove.forEach(item => items.remove(item));
            }
            if (toAdd.length > 0) {
              items.push(...toAdd);
            }
          }
          if (hasChanges) {
            refreshStateToUI();
            // if Change of Selection is triggered outside of angular scope but angular scope is attached
            // force apply if necessaray to refresh UI!
            var scope: ng.IScope;
            if (scope = grid["$angular_scope"]) {
              if (!scope.$root.$$phase)
                scope.$apply();
            }
            this.trigger("CustomSelectionChanged");
          }
        },
        SetRowsSelected(val: boolean, rows: JQuery) {
          var items = rows.toArray().map(r => {
            var item = grid.dataItem(r);
            if (item) {
              $(r).toggleClass("k-state-checked", val);
            }
            return item;
          }).filter(fn.isSet);
          result.SetSelected(val, ...items);
        },
        GetSelectedItems: () => items,
        Revalidate: revalidate
      };
      return result;
    }

    // Remove Items if not available anymore in datasource ...
    function revalidate() {
      var data: ObservableArray;
      if (grid.dataSource && (data = grid.dataSource.data()))
        var check = fn.ToDictionary(data, item => item[fieldName]);

      var missing = customSelection.GetSelectedItems().filter(item => item[fieldName] && !check[item[fieldName]]);
      if (missing.length > 0)
        customSelection.SetSelected(false, ...missing);
    }

    var customSelection = this._exSelection = CreateSelectedItems();

    this.bind("dataBound", OnDataBound);

    OnDataBound();
  }

  /** Custom Checkbox Multi selection Access, attached only for CustomSelectionActive! */
  public GetSelectedItems(): IGridSelection {
    var opt = <NavGridOptions>this.options;
    if (opt.customMultiSelect && !this._exSelection)
      this._initCustomMultiSelect();

    return this._exSelection;
  }
  private _exSelection: IGridSelection;

  private static GetMultiSelectCol() {
    // caution : Function name used in template
    var funcName = (function () {
      const dummy = INavGridImp.ToggleCustomSelection, //
        result = _NameSpace + ".INavGridImp.ToggleCustomSelection",
        vaildated = kendo.getter(result + ".constructor")(window); // just to catch this name when refactoring
      return result;
    })();
    return <kendo.ui.GridColumn>{
      resizable: false, reorderable: true, sortable: true, groupable: true, columnMenu: true, width: constants.KendoGrid_SelectionColumnSize,
      template: '<input type="checkbox" kendo-check-box class="navRowCheckbox" onchange="' + funcName + '(event);"></input>',
      headerTemplate: '<input type="checkbox" kendo-check-box class="navheaderCheckbox"></input>',
    };
  }

  /** Marker : Our Custom Selection Logic is active here! */
  CustomSelectionActive: boolean;

  /** Toggle Selection of Row from Row Base Mouse Event bound to Checkbox */
  static ToggleCustomSelection(event: MouseEvent) {
    var cb = <any>event.currentTarget || event.target;
    var row = $(cb).closest("tr");
    var grid = <INavGrid>GetGrid(event);
    if (!grid)
      throw Error("Grid not found from MouseEvent");
    if (!grid.trigger("ToggleCustomSelection", { sender: grid, event: event, row: row })) {
      grid.GetSelectedItems().SetRowsSelected(cb.checked, row);
      grid.select(row);
    }
  }
  //#endregion

  addDynamicColumns(start: number, cols: kendo.ui.GridColumn[]) {
    const removeCols = () => {
      const _allColumns = this._allColumns;
      cols.forEach(element => {
        var idx = _allColumns.indexOf(element);
        if (idx >= 0) {
          _allColumns.splice(idx, 1);
        }
      });
    };

    removeCols();
        this._allColumns.splice(start, 0, ... cols);

    return fn.once(() => removeCols());
  }

  /** With Custom Column Selection the "getOptions().columns" will only get the "actually displayed columns" not "all"
  - return base Columns keeping in sync "hidden", "width" and order of columns */
  getAllColumns() {
    var displayCols = this.getOptions().columns,
      optCols = (displayCols || []).filter(k => !!k.field).map((item, idx) => { return { Col: item, Idx: idx }; });
    var allCols = this._allColumns;
    if (allCols) {
      var map = fn.ToDictionary(optCols, r => r.Col.field);
      allCols.forEach((c, idx) => {
        var m = map[c.field];
        if (m) {
          c.hidden = m.Col.hidden;
          c.width = m.Col.width;
        }
      });
      return fn.sort(allCols, c => !c.field ? -1 : ((c.field in map) ? map[c.field].Idx : optCols.length + 1)); // Sort visible columns
    }
    return displayCols;
  }
  /** In Case we do not display all Cols we must keep the 'original set
  - as base fo selection
  - as base for settings storage'
  and keep with, hidden, order in sync with actually displayed columns
   */
  private _allColumns: kendo.ui.GridColumn[];

  private _initCustomColSelection(allColumns: kendo.ui.GridColumn[]) {
    var me = this;
    var options = <NavGridOptions>this.options,
      actCols = this.createAction("ColumnSelect", editColumns, { Enabled: !!allColumns && allColumns.length > 0 });

    if (!actCols.Enabled)
      return;
    this._allColumns = allColumns;

    this.bind("columnMenuInit", (e: { container: JQuery }) => {
      var p = e && e.container && e.container.data('kendoPopup');

      if (p) {
        var mnuItem = $('<li class="k-item k-columns k-state-default" role="menuitem"><span class="k-link"><span class="k-sprite k-i-columns"></span>Spalten ...</span></li>');
        mnuItem.on("click.nav", () => {
          var x = actCols.Execute(p);
          if (x && x["then"]) {
            x.then(() => p.close());
          } else {
            p.close();
          }
        });
        this.bind(constants.NavDestroy, () => mnuItem.off(".nav"));
        $("ul", p.element).first().append(mnuItem);
        $('<li class="k-separator k-item k-state-default" role="menuitem">&nbsp;</li>').insertBefore(mnuItem);
      }
    });

    function editColumns(p?: kendo.ui.Popup) {
      var beforeOpen = options.beforeOpenColumnSelection && options.beforeOpenColumnSelection(me);
      if (beforeOpen && beforeOpen["then"]) {
        return beforeOpen.then(() => showColumnsModal(p));
      }
      return showColumnsModal(p);
    }

    function showColumnsModal(p?: kendo.ui.Popup) {
      var allCols = allColumns.filter(f => !!f.field),
        allColMap = fn.ToDictionary(allCols, "field"),
        fixedCols = allColumns.filter(f => !f.field),
        visibleColumns = me.getOptions().columns.filter(item => !!item.field && !item.hidden).map(c => allColMap[c.field]);

      if (p && (p instanceof kendo.ui.Popup)) {
        p.close();
      }
      return ModalShowMultiSelect({
        context: me.wrapper,
        AllItems: allCols.sort((a, b) => (a.title || "").localeCompare(b.title || "")),
        ChosenItems: visibleColumns,
        TitleUnchosen: "Verfügbare Spalten",
        TitleChosen: "Angezeigte Spalten",
        TemplateUnchosen: $(
          `<div style='padding: 2px 6px' ng-class="model.Marked ? 'idms_CommandControl_Selected' : ''" >
                            {{item.title}}
                        </div>`),
        TemplateChosen: $(
          `<div style='white-space: nowrap; padding: 2px 6px' ng-class='model.Marked ? "idms_CommandControl_Selected" : ""' >
                            <div class='selitem_index'>{{model.Index + 1}}.</div>
                            <div class='selitem_text'>{{item.title}}</div>
                        </div>`),
        events: {
          apply: applySelectedColumns,
          revert: fn.noop
        },
        filter: (item, text) => {
          return (item.title || "").toLowerCase().indexOf((text || "").toLowerCase()) >= 0;
        },
      });

      function applySelectedColumns(selectedCols: kendo.ui.GridColumn[]) {
        // why are cols not object - equal?
        selectedCols = selectedCols.map(item => fn.FindFirst(allColumns, "field", item.field)).filter(fn.isSet);

        if (!selectedCols || !(selectedCols.length > 0))
          throw new Error("Es muss mindestens eine Spalte sichtbar sein!");

        var newCols = fixedCols.slice(0);
        newCols.push(...selectedCols);
        allColumns.forEach(c => c.hidden = true);
        newCols.forEach(c => c.hidden = false);
        fn.sort(allColumns, c => newCols.indexOf(c));

        // Recreate with new Columns Setup
        me.reCreate(o => o.columns = INavGridImp._customCols(o, allColumns));
        me.trigger("customColumnChange");
      }
    }
  }

  /** adjust cols for "customColMenu" = "do not display hidden columns scenario" */
  static _customCols(options: kendo.data.DataSource | NavGridOptions, allCols: kendo.ui.GridColumn[]) {
    var result = allCols.filter(item => !item.field || !item.hidden),
      addCols = GetGroupInfo(options).map(c => fn.FindFirst(allCols, "field", c.field))
        .filter(fn.isSet).filter(c => result.indexOf(c) < 0);

    result.push(...addCols);

    return result;
  }

  /** Current Grouping State Information Object for Persistence (Gets attached from Initialization with active storeGroupingState flag) */
  GroupingState: IGroupingState;

  /** Initialize Grouping State Information/ Handling */
  private _initGroupingState(gTemplate?: IGroupingState, keyField?: string) {
    let me = this;
    let copiedGroupingState = $.extend(true, {}, gTemplate || {});
    let _root = me.GroupingState = copiedGroupingState; // Copy necessary!! (to be comparable to orig!)
    fn.ExtendObject(_root, <IGroupingState>{ c: false, selected: [] });

    var actToggleExpandAll = me.createAction("GroupToggleAll",
      fn.proxy(_setAllCollpased, null), { Hidden: "Enabled", Enabled: false });

    /** set/toggle all collapsed state */
    function _setAllCollpased(state?: boolean) {
      _root.c = state !== undefined ? !!state : !_root.c;
      delete _root.s;
      if (_root.c)
        delete _root.selected;
      _applyGroupInfo();
    };
    /** set collapse state to UI for GroupingRow */
    function _setCollapse(row: JQuery, state: boolean) { state ? me.collapseRow(row) : me.expandRow(row); }
    /** check for IsEmpty (recursively) */
    function _empty(g: IGroupingState) {
      if ("c" in g || "selected" in g)
        return false;
      if (!("s" in g))
        return true;
      return Object.keys(g.s).every(v => _empty(g.s[v]));
    }
    /** reduce State Information removing invalid/redundant info (recursively) */
    function _reduceState(groups: Array<{ field: string }>, state: IGroupingState) {
      var group = groups && groups[0],
        rGroups = groups && groups.slice(1),
        curr = state && state.s;

      if (!group || !group.field || !curr || $.isEmptyObject(curr)) {
        if (state)
          delete state.s;
        return;
      }
      Object.keys(curr).forEach(fName => {
        var fVal = curr[fName];
        if (fName !== group.field)
          delete curr[fName]; // Not a current group info
        else if (curr[fName] && groups.length > 0) {
          if (fVal.c == _root.c)
            delete curr[fName];
          else {
            Object.keys(fVal.s).forEach(v => {
              var xsv = fVal.s[v];
              _reduceState(rGroups, xsv); // reduce Child group info
              if (_empty(xsv)) {
                delete fVal.s[v];
              }
            });
          }
        }
        if (fVal && _empty(fVal))
          delete curr[fName];
      });
      if ($.isEmptyObject(curr))
        delete state.s;
    }
    /** Get next level for given field/Value combination */
    function _nextLevel(g: IGroupingState, field: string, value: any) {
      var goupValues = g.s || (g.s = {}),
        fieldValue = goupValues[field] || (goupValues[field] = <IGroupingState>{}),
        values = fieldValue.s || (fieldValue.s = {});
      return values["" + value] || (values["" + value] = <IGroupingState>{});
    };
    /** build Path for grouping information */
    function _groupPath(row: JQuery) {
      var next = (row = row.closest("tr:not(.k-filter-row)")).attr("data-uid") ? row : row.closest("tr:not(.k-filter-row)").nextUntil("[data-uid]").next(),
        item = me.dataItem(next.length ? next : row.next(":not(.k-filter-row)")),
        groupIdx = row.children(".k-group-cell").length,
        allgroups = <Array<{ field: string }>>me.dataSource.group() || [],
        groups = allgroups.slice(0, groupIdx + 1);
      if (item) {
        var result = groups.map((g) => {
          return { field: g.field, value: "" + item[g.field] };
        });
        if (keyField && (keyField in item)) { // for given key add Item for selected Item also
          result.push({ field: keyField, value: "" + item[keyField] });
        }
      }
      return result;
    }
    /** Set Colapse State, either from stored to UI (state is set) or from UI to stored (state is not set) */
    function _rowCollapse(row: JQuery, state?: boolean) {
      var setState = state !== undefined,
        next = row.nextUntil("[data-uid]").next(),
        item = me.dataItem(next.length ? next : row.next()),
        groupIdx = row.children(".k-group-cell").length,
        allgroups = <Array<{ field: string }>>me.dataSource.group() || [],
        groups = allgroups.slice(0, groupIdx + 1),
        /** Current Grouping State (might be null if no set operation */
        curr = groups.reduce((p, c) =>
          p && (p.s || setState) && _nextLevel(p, c.field, item[c.field]), _root);

      if (setState) {
        // store only non default
        if (!("c" in _root) || _root.c !== state)
          curr.c = state;
        else {
          delete curr.c;
          _reduceState(allgroups, _root);
        }
      }
      else if (curr && ("c" in curr)) {
        _setCollapse(row, curr.c);
      } else if ("c" in _root) {
        _setCollapse(row, _root.c);
      }
    }
    /** apply group info for visible groupings to UI */
    function _applyGroupInfo() {
      var groups = me.dataSource && me.dataSource.group();
      var hasGroups = groups && groups.length > 0;
      if (hasGroups)
        me.tbody.children(".k-grouping-row").each((idx, e) => _rowCollapse($(e)));
      _reduceState(me.dataSource.group() || [], _root);
      _refreshActionState(hasGroups);
    }
    /** Flatten Grouped Data info */
    function _flattenGroups(data: kendo.data.GroupInfo[]) {
      var result = [];
      for (var idx = 0, length = data.length; idx < length; idx++) {
        var group = data[idx];
        var items = group && group.items;
        if (items) {
          if (group.hasSubgroups) {
            result = result.concat(_flattenGroups(items));
          } else {
            for (var itemIndex = 0, itemLength = items.length; itemIndex < itemLength; itemIndex++) {
              result.push(items[itemIndex]);
            }
          }
        }
      }
      return result;
    }
    /** Page to given Group Path Information */
    function _pageToGroup(info: IFieldValue[]) {
      var ds: kendo.data.DataSource,
        group: any[];

      if (!info || !(ds = me.dataSource) || !(group = ds.group()))
        return;
      var dsData = (ds.data() || new ObservableArray([])).map(fn.identity),
        currView = kendo.data.Query.process(dsData, {
          filter: ds.filter(),
          sort: ds.sort(),
          group: ds.group(),
        }).data;

      // Convention last item might be "exact match by key" not by group
      //  if found (and is in group?) postion by match, else , position by group;
      var sGroups = info.slice(0, ds.group().length);
      var exact = sGroups.length < info.length && info[info.length - 1];
      var exactMatch = exact && keyField && exact.field == keyField &&
        fn.FindFirst(ds.data(), item => (exact.field in item) && ("" + item[exact.field] == exact.value && _isMatch(sGroups, item)));

      if (group.length == 0)
        var currIdx = exactMatch && currView.indexOf(exactMatch);
      else
        currIdx = exactMatch && (_flattenGroups(currView).indexOf(exactMatch)) || ((exactMatch = false) == false && - 1); // TODO : Ensure Expanded
      if (!(currIdx > 0)) {
        // Find First index in defined Group if no exact match
        sGroups.map((value) => {
          if (!currView)
            return;
          for (var x = 0; x < currView.length; x++) {
            var curr = currView[x];
            var currValue = curr && curr.value;
            if (("" + currValue) == value.value) {
              currView = curr.items;
              return;
            } else {
              currIdx += _flattenGroups(curr.items).length;
            }
          }
          // no match found on current level!
          currView = undefined;
        });
      }
      if (currIdx >= 0) {
        //page is 1-based index
        var newPage = Math.floor(currIdx / ds.pageSize()) + 1;
        if (newPage !== ds.page()) {
          ds.page(newPage);
        }
        if (exactMatch)
          me.select(me.getRowByUid(exactMatch["uid"]));
      }
    }
    /** Check is dataItem is match by field values */
    function _isMatch(infos: IFieldValue[], item: any) {
      return infos.every(info => ("" + item[info.field]) == info.value);
    }
    /** refresh State of Grouping Related Actions */
    function _refreshActionState(hasGroups: boolean) {
      actToggleExpandAll.Enabled = hasGroups;
      actToggleExpandAll.Checked = _root.c;
      var scope: ng.IScope = me.element["$angular_scope"];
      if (scope && !scope.$root.$$phase)
        scope.$root.$applyAsync();
    }

    // react on click of grouping row
    me.bind(INavGridImp.GridContentCreated, () => {
      me.table.on("click.nav", ".k-grouping-row .k-i-collapse, .k-grouping-row .k-i-expand", function (e) {
        var row = $(this).closest("tr");
        _rowCollapse(row, !$(this).hasClass("k-i-collapse"));
        _refreshActionState(true);
      });
    });

    // atach groups on databind
    me.bind("dataBound", _applyGroupInfo);
    me.bind(INavGridImp.CurrentChanged, (e) => {
      var sel = me.current(),
        info = (sel && sel.length == 1) && _groupPath(sel);
      _root.selected = info || undefined;
    });
    let ds: kendo.data.DataSource;

    if (gTemplate && !_empty(gTemplate) && (ds = me.dataSource) && ds.total() > 0 && ds.pageSize() > 0) {
      // attach initial group info if not empty
      _applyGroupInfo();
      // restore Paging State by selected group Information
      _pageToGroup(gTemplate.selected);
    }
  }

  LeafColumns() {
    var columns = this.columns;
    var result: kendo.ui.GridColumn[] = [];
    for (var idx = 0; idx < columns.length; idx++) {
      if (!columns[idx].columns) {
        result.push(columns[idx]);
        continue;
      }
      // MSQQQ result = result.concat(that.leafColumns(columns[idx].columns));
    }

    return result;
  }

  findNextEditableCell(fromCell: JQuery, back?: boolean): JQuery {
    var that = <INavGrid><any>this;
    var isHeaderCell = this.thead && $.contains(this.thead[0], fromCell && fromCell[0]);
    if (isHeaderCell && !back) {
      check = this.tbody.find("tr[role='row'] td:first");
      if (check.length == 0)
        return;
    } else {
      var check = (back ? $(fromCell).prevAll(constants.GridDataCell) : $(fromCell).nextAll(constants.GridDataCell)).first();
      if (check.length == 0) { // try next row
        var currRow = $(fromCell).parents(constants.GridEditRowSelector).first();
        var nextRow = back ? currRow.prevAll(constants.GridEditRowSelector).first() : currRow.nextAll(constants.GridEditRowSelector).first();

        var nextCells = nextRow.children(constants.GridDataCell);
        check = back ? nextCells.last() : nextCells.first();
        if (check.length == 0)
          return; // EOF
      }
    }
    var column = that.LeafColumns()[that.cellIndex(check)],
      model = that._modelForContainer(check);

    if (!column)
      return; // Error ?
    if (check.is(":visible") && model && model.editable(column.field) && column && column.field && column.infEditable)
      return check;
    else
      return that.findNextEditableCell(check, back);
  }

  /** Custom Override for "EditCell: allow Cancel via editable property on column or by callback */
  editCell(_cell) {
    var that = <INavGrid><any>this,
      cell = $(_cell),
      idx = that.cellIndex(cell),
      column = that.columns[idx],
      field = column && column.field,
      model = that._modelForContainer(cell),
      event = <any>{
        container: cell,
        model: model,
        field: field,
      };
    if ((this.InfReadonly === true) || (column && column.infEditable === false)) {
      return;
    }
    if (model && field && this.trigger("beforeEdit", event)) {
      // don't edit if prevented in beforeEdit
      if (event.isDefaultPrevented()) return;
    }

    super.editCell(cell);
  }

  getRowByUid(uid: string): JQuery {
    return this.table.find('tr[data-uid="' + uid + '"]');
  }

  getHeaderCellInfo(fieldName: string) {
    var cols = this.LeafColumns();
    var len = cols.length;
    for (var i = 0; i < len; i++) {
      if (cols[i].field == fieldName)
        return {
          Index: i + 1,
          Cell: $("th:nth-child(" + (i + 1) + ")", this.thead),
        };
    }
  }

  getCell(uid: string, fieldName: string) {
    var row = this.getRowByUid(uid);
    var cols = this.LeafColumns();
    var len = cols.length;
    for (var i = 0; i < len; i++) {
      if (cols[i].field == fieldName)
        return $("td:nth-child(" + (i + 1) + ")", row);
    }

    return $([]);
  }

  refreshFromModel(model: Model, field: any) {
    if (!model || !model.uid)
      return;
    var that = <INavGrid><any>this;
    var cell = this.getCell(model.uid, (field && field.name) || field);
    if (cell && cell.length && !cell.hasClass("k-edit-cell")) {
      var column = this.LeafColumns()[this.cellIndex(cell)];
      if (column)
        that._displayCell(cell, column, model);
    }
  }

  editCellById(uid: string, fieldName: string) {
    var row: JQuery,
      col = fn.FindFirst(this.LeafColumns(), "field", fieldName);

    // With Custom Col Menu Logic the Column to Show might not be Rendered!
    if (!col && (<NavGridOptions>this.options).customColMenu) {
      col = fn.FindFirst(this._allColumns, "field", fieldName);
      if (col) {
        col.hidden = false;
        this.reCreate(o => {
          o.columns.push(col);
          return true;
        });
      }
    }

    this.clearSelection();
    this.select(row = this.getRowByUid(uid));
    if (row) {
      this.LeafColumns().forEach((item, idx) => {
        if (item.field == fieldName) {
          col = item;
          this.showColumn(fieldName);
          this.editCell($("td:nth-child(" + (idx + 1) + ")", row));
        }
      });
    }
  }

  /** ReCreate Grid with Manipulated Options */
  public reCreate(cb: (options: NavGridOptions) => any) {
    var options = this.getOptions();
    if (cb.call(this, options) !== false) {
      // see GetGridOptionSettings ...
      options.dataSource = undefined; // if we took the grid's options: do not set dataSource on set options : will clear!
      this.setOptions(options);
    }
  }

  unselect(rows: JQuery) {
    var that = <INavGrid><any>this;
    that.selectable._unselect(rows);
    that.selectable.trigger("change");
  }

  setOptions(options) {
    this.isSetOptions = true;
    try {
      super.setOptions(options);

      // implicitly "destroys", so reAttach standard token
      this.element.data("kendoGrid", this); // we removed "standard" way to handle this, but used it this way ...

      this.trigger(INavGridImp.GridContentCreated);
    } finally {
      this.isSetOptions = false;
    }
  }

  /** Base setOptions calls destroy (WTF!?!) ;
  * Marker : destroy is currently beeing called from setOptions Call */
  protected isSetOptions: boolean;
  destroy() {
    if (!this.isSetOptions) {
      this.trigger(constants.NavDestroy);
    }
    // Remove events (what about setOptios then?)
    this.table.off(".nav");
    if (this.content) {
      this.content.off(".nav");
    }

    this.element.removeData("kendoGrid");
    super.destroy();
  }
}

// MSQQQ
this['INavGrid'] = INavGridImp;

NavKendoRegister(<any>INavGridImp, "NavGrid");

// Provide some Undocumented Features for standard kendo.ui.Grid
export declare class INavGrid extends INavGridImp {
  /** DO NOT CREATE THIS WAY use, INavGridImp */
  constructor(element, options: kendo.ui.GridOptions);

  /** Undocumented in kendo.d.ts, but used for grid Selection state manipulation */
  selectable: {
    _notify: (event: string) => void;
    _unselect: (rows: JQuery) => void;
    clear: () => void;
    trigger: (name: string) => void;
  };

  /** retrieve model for context */
  _modelForContainer(container: JQuery): Model;

  /** render Cell content from Model/Column in cellsd */
  _displayCell(cell: JQuery, column: kendo.ui.GridColumn, model: Model);

  /** tab Next Base functionality */
  _tabNext(current, currentTable, back): JQuery;

  items(): JQuery;

  /** Force Refresh Of Field for Model (due to bypassing standard kendo model Functionality in NavPageItem (see setModel) */
  refreshFromModel(model: Model, field: any);

  /** Edit Cell by Unique Model Id and Column Name */
  editCellById(uid: string, fieldName: string);

  /** Get Row Selector by  kendo model uid */
  getRowByUid(uid: string): JQuery;

  /** get Cell Selector by uid and field Name*/
  getCell(uid: string, fieldName: string): JQuery;
}

/** Settings Persistence Handling for kendo Grid:
* So far only :
* - Column Width
* - Column Visibility
* - Column Order
* (others are handled in "NavGrid" version so far only)
* */
export function GetGridSettings(kgrid: kendo.ui.Grid): IPersistentSetting<any> {
  return GetGridOptionSettings(kgrid && kgrid.options, () => kgrid);
}

/** Settings Persistence Handling for kendo Grid Options:
  * So far only :
  * - Column Width
  * - Column Visibility
  * - Column Order
  * (others are handled in "NavGrid" version so far only)
  * (to modify Options directly allows to manipulate ´g)
  * */
export function GetGridOptionSettings(exOptions: NavGridOptions, getGrid: () => kendo.ui.Grid): IPersistentSetting<any> {
  return CreateSetting(() => {
    var currGrid = getGrid(),
      options = (currGrid && <NavGridOptions>currGrid.getOptions()) || exOptions,
      columns = currGrid instanceof INavGridImp && currGrid.getAllColumns() ||
        (currGrid && currGrid.getOptions().columns) || (options && options.columns),
      columnInfo = (columns ? columns : []).filter(item => !!item.field).map((c, idx) => {
        return {
          hidden: !!c.hidden,
          field: c.field,
          width: c.width
        };
      });

    if (!currGrid && (!columns || columns.length == 0))
      return undefined;

    var pgSize;
    if (options && options.dataSource) {
      var ds = options.dataSource;
      if (ds.pageSize) {
        var checkSize = ds.pageSize;
        if ($.isFunction(checkSize))
          pgSize = checkSize.apply(ds);
        else if (typeof (checkSize) == "number")
          pgSize = checkSize;
      }

      if (options.groupable) {
        if (ds instanceof kendo.data.DataSource) {
          var groupInfo = <kendo.data.DataSourceSortItem[]>ds.group();
        }
        else if ($.isArray(ds.group))
          var groupInfo = (<any[]>ds.group).map(item => {
            return <kendo.data.DataSourceSortItem>{ field: item.field, dir: item.dir };
          });
      }

      if (options.sortable) {
        if ($.isArray(ds.sort))
          var sortInfo = ($.isArray(ds.sort) ? (<kendo.data.DataSourceSortItem[]><any>ds.sort) : []).map(item => { return { field: item.field, dir: item.dir }; });
        else if (ds instanceof kendo.data.DataSource)
          sortInfo = (ds.sort() || []).map(item => { return { field: item.field, dir: item.dir }; });
        else if ("sort" in ds)
          sortInfo = [];
      }
      if (options.filterable) {
        if (ds instanceof kendo.data.DataSource)
          var filters = (<kendo.data.DataSource>ds).filter();
        else
          var filters = <kendo.data.DataSourceFilters>ds.filter;
        var filterInfo = filters && $.isArray(filters.filters) && filters.filters.map((item: kendo.data.DataSourceFilterItem) => item);
      }
    }
    return {
      PageSize: pgSize,
      ColumnInfo: columnInfo,
      GroupInfo: groupInfo,
      SortInfo: sortInfo,
      FilterInfo: filterInfo,
      GroupState: (options && options.storeGroupingState && currGrid instanceof INavGridImp && currGrid.GroupingState) || undefined
    };
  }, state => {
    var currGrid = getGrid(),
      gridOptions = (currGrid && currGrid.getOptions()),
      options = <NavGridOptions>(gridOptions || exOptions),
      columns = (exOptions && exOptions.columns && exOptions.columns.length && exOptions.columns) || (gridOptions && gridOptions.columns);

    if (currGrid instanceof INavGridImp)
      columns = currGrid.getAllColumns();

    if (!options || !columns)
      return;

    let pageable = options && options.pageable;

    if (state.PageSize > 0 && pageable) {
      if (typeof pageable != "boolean") { // might per kendo.ui.Pager (not in all.d.t.s but in code)
        pageable.pageSize = state.PageSize;
      }
      // TODO : Better initialize DataSource - options before DataSource Creation
      if (options.dataSource) {
        options.dataSource._pageSize = state.PageSize;
        options.dataSource._take = state.PageSize;
        if (options.dataSource.options)
          options.dataSource.options.pageSize = state.PageSize;
      }
    }
    var storedColInfo = fn.ToDictionary(state.ColumnInfo.map((c, idx) => {
      return { col: c, idx: idx };
    }), item => item.col.field);

    // Apply Hidden/Width per Column
    columns.forEach(col => {
      var colInfo = storedColInfo[col.field];
      if (colInfo) {
        col.hidden = !!colInfo.col.hidden;
        if (colInfo.col.width)
          col.width = colInfo.col.width;
      }
    });
    // Order Columns in stored Order
    fn.sort(columns, c => {
      var info = storedColInfo[c.field];
      return info && info.idx >= 0 ? info.idx : (c.field ? 0 : -1);
    });

    options.columns = columns;
    var ds = [options.dataSource, exOptions && exOptions.dataSource].filter(item => item instanceof kendo.data.DataSource)[0];
    if (ds instanceof kendo.data.DataSource) {
      if (options.groupable && state && $.isArray(state.GroupInfo) && JSON.stringify(ds.group()) !== JSON.stringify(state.GroupInfo)) {
        ds.group(state.GroupInfo);
      }

      if (options.sortable && state && $.isArray(state.SortInfo) && JSON.stringify(ds.sort()) !== JSON.stringify(state.SortInfo)) {
        ds.sort(state.SortInfo);
      }
      var filter = state.FilterInfo;
      if ((!options.noRestoreFilter) && filter && filter.length > 0)
        try {
          // TODO : Typed Persistence : Date Field Typed restore (Manipulate cloned objects)
          filter = $.extend([], filter);
          filter.forEach(f => f.value = kendo.parseDate("" + f.value) || f.value);
          ds.filter(filter);
        } catch (err) {
          ds.filter([]);
          window.setTimeout(() => {
            // tslint:disable:ban
            alert("Fehler beim Wiederherstellen des Filters (TODO): " + fn.resolveToError(err));
          });
        }
    }
    options.groupingState = options.storeGroupingState && state.GroupState;
    if (currGrid) {
      let gridBoundSource = currGrid.dataSource;
      // Bug in kendo Grid : Events attached to Column Menu On Show will not get properly detached
      // as events get cleared before unbind
      // Error Occurs when
      // 1.) Column Show(Hide Menu is Shown)
      // 2.) setOptions is called
      // 3.) Column Show Hide via Column Menu is triggered
      // worakaround : call _destroyColumnAttachments explicicitly beforehand
      (<any>currGrid)._destroyColumnAttachments();

      // With custom col menu we generate only visible ones
      if (currGrid instanceof INavGridImp && (<NavGridOptions>currGrid.options).customColMenu !== false)
        options.columns = INavGridImp._customCols(options, options.columns);

      if (gridOptions) // if we took the grid's options: do not set dataSource on set options : will clear!
        options.dataSource = undefined;

      currGrid.setOptions(options);
      // "_NoAutoBind" : Hack : for Lookup
      if (gridBoundSource && !(gridBoundSource["_NoAutoBind"] == true)) {
        // Page Data will vanish otherwise (?)
        gridBoundSource.page(0);
      }
    }
  });
}

/**  Create Grid Overlay [Overlay Column Menus, ] */
function CreateGridOverlay(kGrid: kendo.ui.Grid) {
  if (kGrid) {
    kGrid.bind("columnMenuInit", (e: { container: JQuery }) => e && e.container && CreatePopUpOverlay(e.container.data('kendoPopup')));
  }
  //TODO : Attached other ContextMenus?
}

/** Conditionally apply Row/ Cell Customizations to data Rows of Grid, returns unbind function */
export function BindGridCustomizations(grid: INavGridImp, customization: IGridCustomization, config?: { CurrentUser?: string }) {
  var rowItems = customization && customization.RowCustomizations;
  if (!(((rowItems && rowItems.length)) && (grid instanceof INavGridImp)))
    return fn.noop;

  const rowInfo = ensureRowInfo(grid, customization, config);

  var rowMatcher = rowInfo.RowMatcher,
    fFields = rowInfo.Fields;

  /** Container of Action to reset current Customizations */
  var reset = new Array<() => void>();

  function applyCustomizations() {
    reset.length = 0;
    var rows = $("tr:not('.k-grouping-row')", grid.content || grid.tbody);

    // Calculate Fields Current Indices if necessary for apply Styles to cells
    if (fFields && fFields.length) {
      var colNames = grid.LeafColumns().map(item => item.field || "");
      var idxes = fn.ToDictionaryEx(fFields, f => <string>f.Field, f => colNames.indexOf(<string>f.Field));
    }

    rows.each((idx, el) => {
      var item = grid.dataItem(el),
        info = item && rowMatcher(item);

      if (item) {
        if (info) {
          reset.push(ApplyStyle($(el), info));
        };

        fFields.forEach(f => {
          var i = f.Matcher(item);
          if (i) {
            var idx = idxes && idxes[f.Field];
            if (idx >= 0) {
              var cellInfo = $("td:nth-child(" + (idx + 1) + ") div:only-child", el);
              if (cellInfo.length == 0) {
                // TODO : not a single div in cell : not nice : no 'border' ...
                var cellInfo = $("td:nth-child(" + (idx + 1) + ")", el);
              } else {
                // custom handling for single div in Cell (as with 'special' markup Columns in KWF)
                cellInfo.addClass("idms_GridCellMarked");
              }
              reset.push(ApplyStyle(cellInfo, i));
            }
          }
        });
      }
    });
  };

  grid.bind("dataBound", applyCustomizations);
  applyCustomizations();

  // Setup Reset
  var unbind = (remove: boolean) => {
    unbind = fn.noop;
    if (grid) {
      grid.unbind("dataBound", applyCustomizations);
      if (remove) {
        reset.forEach(r => r());
      }
    }
    reset.length = 0;
  };
  grid.bind(constants.NavDestroy, () => unbind(false));
  return () => unbind(true);
}

/** Interface Describing Selection State */
export interface IGridSelection {
  /** for internal use*/
  SetSelected(val: boolean, ...objs: kendo.data.ObservableObject[]);
  /** internal */
  SetRowsSelected(val: boolean, rows: JQuery);
  /** for internal use */
  GetSelected(obj: kendo.data.ObservableObject): boolean;
  /** for internal use */
  ClearSelection();
  /** Access to Collection of Selected Elements, do not manipulate from outside at the moment opn for binding */
  GetSelectedItems(): ObservableArray;
  /** Revalidate Selection */
  Revalidate(): void;
}

/** Custom Extended Grid Options for kendo- Grid extension 'INavGridImp' */
export interface NavGridOptions extends kendo.ui.GridOptions {
  /** DblClick on Item Event (CAUTION : if handling via grid.content.on('dblclick') : be aware of might get recreated! */
  dblClick?: (ev: { item: Observable, event: Event }) => any;
  /** Before Edit Cell Event (cancellable) */
  beforeEdit?: (item: GridCellEvent) => void;
  /** Store Grouping State (to persist during paging and in settings if any), key : If set : Unique Identifier field for a display Item */
  storeGroupingState?: { key: string } /* | boolean */;
  /** grouping State to apply on load (in our case : from Persistence)  */
  groupingState?: IGroupingState;
  /** Ignore Filter on Restore of userSettings */
  noRestoreFilter?: boolean;
  /** if not explicity false : only visible columns get rendered + custom Column selection */
  customColMenu?: boolean;
  /** Optional hook executed before opening custom column popup */
  beforeOpenColumnSelection?: (grid: INavGridImp) => any;
  /** custom multiselect with checkboxes (string : identifying field name) */
  customMultiSelect?: boolean | string;
  /** Description displayed on active grouping */
  groupingDescription?: string;
}

export interface GridCellEvent extends kendo.ui.GridEvent {
  container: JQuery;
  model: any;
  field: string;
}

/** Persisted Grouping State Information */
export interface IGroupingState {
  /** for Root Element : currently selected path */
  selected?: IFieldValue[];
  /** Collapse Info for Current Level (if Value Level) */
  c?: boolean;
  /** Sub Levels Grouping State */
  s?: { [valueOrField: string]: IGroupingState };
}

export interface IFieldValue {
  field: string;
  value: any;
}

declare global {

  /**  Defined kendo Widgets in this file are automatically available on JQuery ...*/
  interface JQuery {
    /** Custom extension of Grid:
    * -Custom Selection Logic, Row Navigation, ....
    */
    kendoNavGrid(options: NavGridOptions): JQuery;
    data(key: "kendoNavGrid"): INavGrid;
  }
}
